import React, {useEffect, useState} from 'react';
import KickImage from 'Reuseables/KickImage';
import ResetPassword from "../../../images/reset-password.png"
import EmailSent from "../../../images/email-sent.png"
import {withRouter} from 'react-router-dom'

function PageForgotPasswordSuccess({location}) {

  const [isForgotPassword, setIsForgotPassword] = useState(false)

  useEffect(() => {
    let {pathname} = location

    if(pathname.includes('forgot-password')){
      setIsForgotPassword(true)
    }
  }, [])

  return (
    <div className="forgot-password__Success">
      <div className="forgot-password__Container">
        <KickImage className={isForgotPassword ? "forgot-password-img" : "reset-password-img"} src={isForgotPassword ? EmailSent : ResetPassword} alt="Success Forgot Password"/>
        <h4>Well done!</h4>
        <p>{isForgotPassword ? "We already send a link to your mail." :"Your password has been changed. Happy Shopping!"}</p>
      </div>
    </div>
  )
}

export default withRouter(PageForgotPasswordSuccess)